/* global TokenizeJs */
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import { fetchShippingMethods } from './PaymentRequestApi';
import DigitalWalletStore, {
  DigitalWalletConstants,
  APPLE_PAY,
  GOOGLE_PAY
} from './DigitalWalletStore';

const { dispatchServerAction } = AppDispatcher;

class PoyntPaymentRequestActions {
  async init() {
    const {
      poynt_config: { sdk_url }
    } = OlsConfigStore.getState();

    if (DigitalWalletStore.getState().poyntWasLoaded) {
      return;
    }

    const data = await fetchShippingMethods();
    if (!data.length) {
      dispatchServerAction({
        type: DigitalWalletConstants.NO_SHIPPING_METHODS
      });
      return;
    }

    const script = window.document.createElement('script');
    script.src = sdk_url;
    script.type = 'text/javascript';
    script.onload = () => {
      dispatchServerAction({
        type: DigitalWalletConstants.POYNT_WAS_LOADED
      });
    };
    window.document.body.appendChild(script);
  }

  buildLineItems(order) {
    const lineItems = [];

    if (order && order.summary_line_items) {
      for (const item of order.summary_line_items) {
        lineItems.push({
          label: item.label,
          amount: item.amount,
          type: 'final'
        });
      }
    }

    return lineItems;
  }

  buildShippingMethods(order) {
    const methods = [];

    if (order?.shipping_rates) {
      for (const rate of order.shipping_rates) {
        methods.push({
          id: rate.id.toString(),
          label: rate.method,
          detail: '',
          amount: rate.cost
        });
      }
    }

    return methods;
  }

  updatePaymentRequest(order, error = false) {
    const { store_name } = OlsConfigStore.getState();

    const paymentRequest = {
      total: {
        amount: order?.balance_due ? order.balance_due : '0.00',
        label: store_name,
        type: 'final'
      },
      shippingMethods: this.buildShippingMethods(order),
      lineItems: this.buildLineItems(order)
    };

    if (error) paymentRequest.error = error;

    return paymentRequest;
  }

  buildPaymentRequest(initPage) {
    const {
      country_iso,
      currency,
      store_name,
      show_coupon,
      stripe_config: { require_phone_number }
    } = OlsConfigStore.getState();
    const lineItems = this.buildLineItems();
    const shippingMethods = this.buildShippingMethods();
    const supportCouponCode = show_coupon && initPage === 'product_detail';

    return {
      merchantName: store_name,
      country: country_iso,
      currency: currency.code.toUpperCase(),
      requireEmail: true,
      requireShippingAddress: true,
      requirePhone: require_phone_number,
      lineItems,
      supportCouponCode,
      shippingMethods,
      total: {
        amount: '0',
        label: store_name,
        type: 'final'
      }
    };
  }

  checkAvailability() {
    const { poyntWasLoaded } = DigitalWalletStore.getState();
    const { business_id, application_id } = OlsConfigStore.getState().poynt_config;

    dispatchServerAction({
      type: DigitalWalletConstants.AVAILABILITY_WAS_CHECKED
    });

    if (poyntWasLoaded && typeof TokenizeJs !== 'undefined') {
      const paymentRequest = this.buildPaymentRequest();
      this.poyntCollect = new TokenizeJs(business_id, application_id, paymentRequest);
      this.poyntCollect.supportWalletPayments().then(data => {
        dispatchServerAction({
          type: DigitalWalletConstants.POYNT_PAYMENT_REQUEST_IS_AVAILABLE,
          data
        });
      });
    }
  }

  getPaymentMethods() {
    const paymentMethods = [];
    const { applePayIsAvailable, googlePayIsAvailable } = DigitalWalletStore.getState();

    if (applePayIsAvailable) paymentMethods.push(APPLE_PAY);
    if (googlePayIsAvailable) paymentMethods.push(GOOGLE_PAY);

    return paymentMethods;
  }
}

export default new PoyntPaymentRequestActions();
